import './App.css';
import Register from './Register';
import SuccessRegister from './SuccessRegister';
import { Routes, Route } from 'react-router-dom';
import background from "./assets/img/Background.png";
import Start from './Start';
// import { createTheme, ThemeProvider } from '@mui/material/styles';

// const theme = createTheme({
//   palette: {
//     blue: '#5B9BD5',
//     green: '#A7DB8C',
//     orange: '#F4B183',
//   },
// });

function App() {
  // var backgroundStyle = {
  //   backgroundImage: `url(${background})`,
  //   backgroundPosition: 'center',
  //   backgroundSize: 'contain',
  //   backgroundRepeat: 'repeat',
  //   // width: '100vw',
  //   height: '100vh'
  // };
  return (
      <div className='background-image' >
        <Routes>
          <Route path="register" element={<Register />} />
          <Route path="/" element={<Start />} />
          <Route path="successreg" element={<SuccessRegister />} />
        </Routes>
      </div>
  );
}

export default App;
